module.exports = require("@swa-ui/href/createHrefWithSearchParams");